import { memo } from 'react';

import { Label, Text, Tooltip, TooltipTrigger } from '@/components/core';
import { DivProps, OmitChildren } from '@/utils';

export type FieldLabelProps = {
  description?: string;
  name: string;
  hideLabel?: boolean;
} & OmitChildren<DivProps>;

const IFieldLabel = ({ name, description, hideLabel = false, ...rest }: FieldLabelProps) => {
  return (
    <div className="group/field-label flex items-center gap-2" {...rest}>
      <TooltipTrigger isDisabled={!description}>
        <Label hidden={hideLabel} htmlFor={name}>
          {name}
        </Label>

        <Tooltip placement="left">
          <Text className="text-white">{description}</Text>
        </Tooltip>
      </TooltipTrigger>
    </div>
  );
};

export const FieldLabel = memo(IFieldLabel) as typeof IFieldLabel;
